<template>
  <div class="wrapper-qrcode-form">
    <!-- Client Options -->
    <section>
      <div class="row">
        <div class="col">
          <section-title
            :title="$t('apps.pos.label.customer')"
            fontweight="bold"/>
        </div>
      </div>
      <div class="row row-input">
        <div class="col-12">
          <label>{{ $t('apps.pos.message.qrcodeappprovider') }}</label>
          <select
            v-model="myForm.appProvider"
            :disabled="isSubmitted || disabled"
            class="custom-select form-control">
            <option value="web">{{ $t('apps.pos.message.defaultqrcodeappproviderweb') }}</option>
            <option value="line">{{ $t('apps.pos.message.defaultqrcodeappproviderline') }}</option>
          </select>
        </div>
        <div class="col-12">
          <label>{{ $t('apps.pos.message.qrcodetype') }}</label>
          <select
            v-model="myForm.qrcodeType"
            :disabled="isSubmitted || disabled"
            class="custom-select form-control">
            <option value="one_time_use">{{ $t('apps.pos.message.qrcodetypeonetimeuse') }}</option>
            <option value="reusable">{{ $t('apps.pos.message.qrcodetypereusable') }}</option>
          </select>
        </div>
        <div class="col-12">
          <label>{{ $t('apps.pos.message.qrcoderequestapproveacess') }}</label>
          <div>
            <vs-checkbox
              v-model="myForm.isClientApproveAccessRequired"
              :disabled="isSubmitted || disabled"
              color="#A3CA76"
              style="float: left;position: relative;top: 1px;left: -5px;">
              <span v-if="!myForm.isClientApproveAccessRequired">{{ $t('message.no') }}</span>
              <span v-else>{{ $t('message.yes') }}</span>
            </vs-checkbox>
          </div>
        </div>
        <div class="col-12">
          <label>{{ $t('apps.pos.message.qrcoderequestapproveorder') }}</label>
          <div>
            <vs-checkbox
              v-model="myForm.isClientApproveOrderRequired"
              :disabled="isSubmitted || disabled"
              color="#A3CA76"
              style="float: left;position: relative;top: 1px;left: -5px;">
              <span v-if="!myForm.isClientApproveOrderRequired">{{ $t('message.no') }}</span>
              <span v-else>{{ $t('message.yes') }}</span>
            </vs-checkbox>
          </div>
        </div>
        <div
          v-if="isShowExpire"
          class="col-12">
          <label>{{ $t('apps.pos.message.qrcodeexpiretime') }}</label>
          <div>
            <input
              v-model="myForm.expireTime"
              :disabled="isSubmitted || disabled"
              type="text"
              class="form-control number-only text-select-all"
              @keypress="numberOnly">
          </div>
        </div>
      </div>
    </section>

    <!-- Restaurant Options -->
    <section class="mt-4">
      <div class="row">
        <div class="col">
          <section-title
            :title="$t('apps.pos.label.restaurant')"
            fontweight="bold"/>
        </div>
      </div>
      <div class="row row-input">
        <div
          v-if="isShowBranch"
          class="col-12">
          <label>{{ $t('apps.pos.label.branch') }}</label>
          <select
            v-model="myForm.branchId"
            :disabled="isSubmitted || disabled"
            class="custom-select form-control"
          >
            <option
              v-for="(branchItem, branchIndex) in branches"
              :key="branchIndex"
              :value="branchItem.branchId"
            >
              {{ branchItem.name }}
            </option>
          </select>
        </div>
        <div
          v-if="isShowPosSession"
          class="col-12">
          <label>{{ $t('apps.pos.label.possession') }}</label>
          <select
            v-model="myForm.psId"
            :disabled="isSubmitted || disabled"
            :class="['custom-select form-control', {
              'is-invalid': isInvalidPosSession
            }]"
          >
            <option
              v-for="(psItem, psIndex) in posSessions"
              :key="psIndex"
              :value="psItem.ps_id"
            >
              {{ psItem.ps_code }}
            </option>
          </select>
          <div
            v-if="isInvalidPosSession"
            class="invalid-feedback">
            {{ $t('apps.pos.message.pleaseopensalebeforecreateqrcode') }}
          </div>
        </div>
        <div class="col-12">
          <label>{{ refName }}</label>
          <select
            v-model="myForm.table"
            :disabled="isSubmitted || disabled"
            :class="[
              { 'is-invalid': !myForm.table }
            ]"
            class="custom-select form-control"
          >
            <option :value="null">
              {{ $t('placeholder.select') }}
            </option>
            <option
              v-for="(item, index) in tableLists"
              :value="item.name"
              :key="index">
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getMasterDataText } from '@/helpers'

export default {
  props: {
    form: Object,
    isSubmitted: Boolean,
    branches: Array,
    posSessions: Array,
    defaultValues: Object,
    disabled: Boolean,
  },

  data() {
    return {
      myForm: {
        appProvider: null,
        qrcodeType: null,
        isClientApproveAccessRequired: null,
        isClientApproveOrderRequired: null,
        expireTime: null,
        branchId: null,
        psId: null,
        table: null,
      },
    }
  },

  computed: {
    ...mapGetters({
      posSettings: 'getPosSetting',
    }),
    isShowExpire() {
      return this.myForm.qrcodeType === 'one_time_use'
    },
    isShowBranch() {
      return this.branches.length > 1
    },
    isShowPosSession() {
      return this.myForm.qrcodeType === 'one_time_use'
    },
    isInvalidPosSession() {
      if (this.myForm.qrcodeType === 'one_time_use' && !this.myForm.psId) {
        return true
      }
      return false
    },
    refName () {
      return getMasterDataText(this.posSettings.table.ref_name, this.$t)
    },
    tableLists() {
      return this.posSettings.table.lists.filter((item) => item.is_active)
    },
  },

  watch: {
    myForm: {
      handler () {
        this.$emit('update:myForm', this.myForm)
      },
      deep: true,
    },
  },

  created() {
    /**
     * set default value
     */
    if (this.defaultValues) {
      if (this.defaultValues.appProvider) {
        this.myForm.appProvider = this.defaultValues.appProvider
      }

      if (this.defaultValues.qrcodeType) {
        this.myForm.qrcodeType = this.defaultValues.qrcodeType
      }

      if (this.defaultValues.isClientApproveAccessRequired != null) {
        this.myForm.isClientApproveAccessRequired = this.defaultValues.isClientApproveAccessRequired
      }

      if (this.defaultValues.isClientApproveOrderRequired != null) {
        this.myForm.isClientApproveOrderRequired = this.defaultValues.isClientApproveOrderRequired
      }

      if (this.defaultValues.expireTime != null) {
        this.myForm.expireTime = this.defaultValues.expireTime
      }

      if (this.defaultValues.branchId) {
        this.myForm.branchId = this.defaultValues.branchId
      }

      if (this.defaultValues.psId) {
        this.myForm.psId = this.defaultValues.psId
      }

      if (this.defaultValues.table) {
        this.myForm.table = this.defaultValues.table
      }
    }

    this.$emit('update:form', this.myForm)
  },
}
</script>

<style scoped>
.row-input > div {
  margin-bottom: 15px;
}
.row-input > div:last-of-type {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/combine/QRCodeForm.vue